import {
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core'
import { Search } from '@material-ui/icons'
import { useEffect, useState } from 'react'
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { listUsers } from '../../../actions/userActions'
import { useInput } from '../../../hooks/useInput'
import SearchInput from '../../Form/SearchInput'
import Loader from '../../Loader/Loader'
import ModalPopUp from '../../ModalPopUp/ModalPopUp'
import Pagination from '../../Pagination/Pagination'
import AddCustomer from '../AddCustomer/AddCustomer'

const Row = styled(TableRow)`
  cursor: pointer;

  &.selected {
    td {
      background: var(--color-light-gray) !important;
    }
  }
`

const CustomTable = styled(Table)`
  max-height: 424px;
  background: white;
`

type SelectUserProps = {
  userId: User['_id']
  setUserId: (userId: string) => void
  setUserSet: (userSet: boolean) => void
}

const SelectUser = ({ userId, setUserId, setUserSet }: SelectUserProps) => {
  const dispatch = useDispatch()
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(25)
  const [filteredUsers, setFilteredUsers] = useState([])
  const [usersSet, setUsersSet] = useState(false)
  const [showSearch, setShowSearch] = useState(false)
  const [showAddCustomer, setShowAddCustomer] = useState(false)
  const { bind: bindSearch, value: searchValue } = useInput('')

  const { users, loading } = useSelector((state: RootStateOrAny) => state.userList)
  const { userInfo } = useSelector((state: { userLogin: UserLogin }) => state.userLogin)

  useEffect(() => {
    if (!usersSet) {
      dispatch(listUsers())
    }

    if (users) {
      setFilteredUsers(users.filter((x: User) => x.role === 'User'))
      setUsersSet(true)
    }
  }, [dispatch, users, usersSet, userInfo])

  useEffect(() => {
    if (searchValue) {
      const filteredUserClone = filteredUsers.filter((x: User) => {
        let name = x.firstName + ' ' + x.lastName
        return name.toLowerCase().includes(searchValue.toString().toLowerCase())
          ? x
          : false
      })
      setFilteredUsers(filteredUserClone)
    } else {
      setFilteredUsers(users)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue, setFilteredUsers])

  const handleUserClick = (id: string) => {
    setUserId(id === userId ? '' : id)
  }

  return (
    <>
      <div className="flex space-between align-center">
        <h4>Select a customer</h4>

        <div className="flex flex-end m-b-16" style={{ height: 37 }}>
          {showSearch ? (
            <SearchInput bindValue={bindSearch} setShowSearch={setShowSearch} />
          ) : (
            <IconButton onClick={() => setShowSearch(true)}>
              <Search />
            </IconButton>
          )}

          <Button
            variant="contained"
            color="primary"
            className="m-l-16"
            onClick={() => setShowAddCustomer(true)}
          >
            Add customer
          </Button>
        </div>
      </div>
      <TableContainer className="scrollable" style={{ maxHeight: 532 }}>
        <CustomTable stickyHeader aria-label="custom pagination table">
          <TableHead>
            <TableRow>
              <TableCell>First Name</TableCell>
              <TableCell>Last Name</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Company</TableCell>
              <TableCell>Location</TableCell>
            </TableRow>
          </TableHead>

          {loading && <Loader />}

          <TableBody>
            {(filteredUsers && filteredUsers.length > 0 && rowsPerPage > 0
              ? filteredUsers.slice(
                page * rowsPerPage,
                page * rowsPerPage + rowsPerPage
              )
              : filteredUsers
            ).map((x: User, index) => (
              <Row
                key={index}
                onClick={() => handleUserClick(x._id)}
                className={x._id === userId ? 'selected' : ''}
              >
                <TableCell>{x.firstName}</TableCell>
                <TableCell>{x.lastName}</TableCell>
                <TableCell>{x.email}</TableCell>
                <TableCell>{x.company && x.company.companyName}</TableCell>
                <TableCell>{x.location}</TableCell>
              </Row>
            ))}
          </TableBody>
        </CustomTable>
      </TableContainer>
      <Pagination
        className="outside"
        setRowsPerPage={setRowsPerPage}
        rowsPerPage={rowsPerPage}
        page={page}
        setPage={setPage}
        rows={filteredUsers}
      />
      <div className="flex flex-end m-t-30">
        <Link to="/myquality/dashboard">
          <Button variant="outlined" color="primary">
            Cancel
          </Button>
        </Link>
        <Button
          variant="contained"
          color="primary"
          style={{ marginLeft: 20 }}
          onClick={() => setUserSet(true)}
          disabled={!userId}
        >
          Next
        </Button>
      </div>
      <ModalPopUp
        title="Add new customer"
        setShowModal={setShowAddCustomer}
        showModal={showAddCustomer}
        variant="medium"
      >
        <AddCustomer setShowAddCustomer={setShowAddCustomer} />
      </ModalPopUp>
    </>
  )
}

export default SelectUser
